import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const LETTERS = "SOURCECODED".split("");
const STATUSES = ["READING YOUR BASELINE", "MAPPING YOUR RHYTHM", "WRITING YOUR SOURCE CODE"];

const IN_MS = LETTERS.length * 30 + 460;
const HOLD_MS = 1400;
const OUT_MS = 220;
const GAP_MS = 140;

export const CompileOverlay = ({ onDone }) => {
  const [cycle, setCycle] = useState(0);
  const [out, setOut] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setOut(true), IN_MS + HOLD_MS);
    const t2 = setTimeout(() => {
      if (cycle >= 1) onDone();
      else {
        setOut(false);
        setCycle((c) => c + 1);
      }
    }, IN_MS + HOLD_MS + OUT_MS + GAP_MS);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [cycle, onDone]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[100] bg-[#0B0B0C] flex items-center justify-center"
      data-testid="compile-overlay"
    >
      <div className="text-center px-5">
        <div className="flex justify-center" style={{ gap: "3px" }}>
          {LETTERS.map((l, i) => (
            <motion.span
              key={`${cycle}-${i}`}
              initial={{ opacity: 0, y: -16, filter: "blur(2.5px)" }}
              animate={out ? { opacity: 0, y: -12, filter: "blur(2px)" } : { opacity: 1, y: 0, filter: "blur(0px)" }}
              transition={
                out
                  ? { duration: 0.22, delay: 0 }
                  : { duration: 0.46, delay: i * 0.03, ease: [0.34, 1.56, 0.64, 1] }
              }
              className="font-mono-brand text-lg font-extrabold text-[#FF4D0A]"
            >
              {l}
            </motion.span>
          ))}
        </div>
        <div className="mt-6 flex items-center justify-center gap-1">
          <AnimatePresence mode="wait">
            <motion.p
              key={cycle}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.25 }}
              className="font-mono-brand text-[11px] tracking-[1.5px] text-[#737687]"
              data-testid="compile-status-line"
            >
              {STATUSES[cycle % STATUSES.length]}
            </motion.p>
          </AnimatePresence>
          <span className="blink font-mono-brand text-[11px] text-[#FF4D0A]">_</span>
        </div>
      </div>
    </motion.div>
  );
};
